import { useContext } from "react";

import { ProductAnalyticsContext } from "./context";

export const useProductAnalyticsContext = () => {
  const context = useContext(ProductAnalyticsContext);

  if (!context) {
    throw new Error(
      "useProductAnalyticsContext can only be used inside ProductAnalyticsContext",
    );
  }

  return context;
};
